import { createSlice } from '@reduxjs/toolkit';
const token = localStorage.getItem("access_token")
const authSlice = createSlice({
    name: 'auth',
    initialState: {
        isAuthenticated: token ? true : false,
        access_token: token,
        refresh_token:null,
        authUser: null
    },
    reducers: {
        login: (state, action) => {
            state.isAuthenticated = true;
            state.access_token = action.payload?.token;
            state.refresh_token = action.payload?.refresh_token;
            state.authUser = action.payload?.authUser
        },
        logout: (state) => {
            state.isAuthenticated = false;
            state.authUser = null;
            state.access_token = null;
            state.refresh_token =null
            localStorage.clear()
        },
    },
});

export const { login, logout } = authSlice.actions;
export default authSlice.reducer;